import Brand from '../../components/Brand'
import NavTabs from './NavTabs'
import ProjectsMenu from './ProjectsMenu'
import AccountMenu from './AccountMenu'
import HelpMenu from '../../help/HelpMenu'
import './TopNav.css'

// Global top bar shared by every authenticated page: brand (left), primary
// tabs (center), help and account menus (right).
function TopNav() {
  return (
    <header className="app-topnav">
      <div className="app-topnav-brand">
        <ProjectsMenu />
        <Brand to="/code" />
      </div>
      <NavTabs />
      <div className="app-topnav-account">
        <HelpMenu />
        <AccountMenu />
      </div>
    </header>
  )
}

export default TopNav
